// Long business names ("Westchester Oral and Maxillofacial Associates, PLLC")
// produce enough initials to wrap inside the avatar, so use at most two.
export function getInitials(name: string) {
  const words = name?.trim().split(/\s+/).filter(Boolean) ?? []

  if (words.length === 0) {
    return ""
  }

  const firstInitial = words[0].substring(0, 1)
  const lastInitial = words.length > 1 ? words[words.length - 1].substring(0, 1) : ""

  return (firstInitial + lastInitial).toUpperCase()
}
